import { forwardRef, ReactNode, ForwardedRef } from "react";
import FaiButtonRoot from "./FaiButtonRoot";

interface FaiButtonProps {
	color?:
		| "white"
		| "primary"
		| "secondary"
		| "info"
		| "success"
		| "warning"
		| "error"
		| "light"
		| "dark"
		| undefined;
	variant?: "text" | "contained" | "outlined" | "gradient" | undefined;
	size?: "small" | "medium" | "large";
	circular?: boolean;
	iconOnly?: boolean;
	type?: "button" | "submit" | "reset";
	children?: ReactNode;
	[key: string]: any;
}

const FaiButton = forwardRef(
	(props: FaiButtonProps, ref: ForwardedRef<any>) => {
		const {
			color = "white",
			variant = "contained",
			size = "medium",
			circular = false,
			iconOnly = false,
			type = "button",
			children,
			className = "",
			...rest
		} = props;

		return (
			<FaiButtonRoot
				{...rest}
				ref={ref}
				color="primary"
				variant={variant === "gradient" ? "contained" : variant}
				size={size}
				type={type}
				className={`!rounded-lg ${className}`}
				ownerState={{ color, variant, size, circular, iconOnly }}
			>
				{children}
			</FaiButtonRoot>
		);
	}
);

export default FaiButton;
